/**
 * Sticky filter tabs on the Catalogue & Orders page: click-to-smooth-scroll (offset
 * for the sticky site header + the tabs bar itself) and IntersectionObserver-driven
 * scrollspy that highlights whichever category section is currently in view.
 */
function initCatalogueTabs() {
  const nav = document.getElementById('CatalogueTabs');
  if (!nav) return;

  const tabs = Array.from(nav.querySelectorAll('[data-tab-target]'));
  const sections = tabs
    .map((tab) => document.getElementById(tab.dataset.tabTarget))
    .filter((section) => section !== null);

  if (!sections.length) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function stickyOffset() {
    const headerHeight = Number.parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 72;
    return headerHeight + nav.offsetHeight;
  }

  function setActiveTab(id) {
    tabs.forEach((tab) => {
      tab.classList.toggle('is-active', tab.dataset.tabTarget === id);
    });
  }

  tabs.forEach((tab) => {
    tab.addEventListener('click', (event) => {
      const target = document.getElementById(tab.dataset.tabTarget);
      if (!target) return;

      event.preventDefault();
      const top = target.getBoundingClientRect().top + window.scrollY - stickyOffset();
      window.scrollTo({ top, behavior: reduceMotion ? 'auto' : 'smooth' });
      setActiveTab(tab.dataset.tabTarget);
    });
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) setActiveTab(entry.target.id);
      });
    },
    {
      root: null,
      // Trigger band starts just below the sticky header+tabs and covers most of the
      // viewport below it, so a section counts as "current" once it's the main thing
      // on screen — not merely peeking in at the very bottom edge.
      rootMargin: `-${Math.round(stickyOffset()) + 1}px 0px -60% 0px`,
      threshold: 0,
    }
  );

  // Deferred by a frame for the same reason as reveal.js: avoids an immediate
  // "already intersecting" callback firing before the browser has painted anything.
  requestAnimationFrame(() => {
    sections.forEach((section) => observer.observe(section));
    setActiveTab(sections[0].id);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCatalogueTabs);
} else {
  initCatalogueTabs();
}
